module.exports = __webpack_public_path__ + "img/ic_teacher_time.2c61ba93.png";